import AbstractProductType from './AbstractProductType'
import { ProductTypeFormat } from './types'

export default class SelfIndoor extends AbstractProductType {

  name = 'self_indoor'
  title = 'Self Indoor'

  format = ProductTypeFormat.Indoor

}
